/**
 * @desc 列表
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<Array<defs.basics.BaseStateModel>>;
export function request(
  body: defs.basics.BaseStateRequestParamsDto,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/basics/baseState/list`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
